export const EXAMINATION_KBN = {
  /** 書類審査 */
  DOCUMENT: '0',
  /** 対面審査 */
  INTERVIEW: '1',
  /** リモート審査 */
  REMOTE_INTERVIEW: '2',
} as const;
